define([
    "dojo/_base/array",
    "./_base"
], function(array,csiAccess){

	return function() {
		// summary: takes all parameters in the form of {"Role:<access>,...} objects
		// and creates an object suitable for csiAccess.addViewRoles call in the form:
		// { "Role":<access>,... }
		var accessObj = {};
		accessObj[csiAccess.DEFAULT_RESOURCE_ACCESS_KEY] = csiAccess.RESOURCE_NO_ACCESS;
		for (var i=0; i < arguments.length; ++i) {
			var a = arguments[i];
			for (var k in a) {
				// 'k' here is the role ID
				accessObj[k] = Math.max(accessObj[k]||0, a[k]);
			}
		}
		return accessObj;
	};
});